import { webTypeApiUrl } from "@/constants/webTypeApiUrl";


export const AuthenticationHandler = {
  MyFunction: function (param) {
    alert(param);
  },
  ChangeSalesAgentPasswords: function (form, tutorChatToken) {
    let result = null;
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/ChangeSalesAgentPasswords",
      type: "post",
      cache: false,
      async: false,
      data: {
        OldPassword: form.oldpassword,
        NewPassword: form.newpassword,
        tutorChatToken: tutorChatToken
      },
      dataType: "json",
      success: function (data) {
        result = data;
        console.log(result);
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });

    return result;
  }
};



// WEBPACK FOOTER //
// ./src/handler/AuthenticationHandler.js